import { render } from "./ChannelBoard.vue?vue&type=template&id=4e7a061e&scoped=true"
import script from "./ChannelBoard.vue?vue&type=script&lang=js"
export * from "./ChannelBoard.vue?vue&type=script&lang=js"

import "./ChannelBoard.vue?vue&type=style&index=0&id=4e7a061e&lang=sass"
import "./ChannelBoard.vue?vue&type=style&index=1&id=4e7a061e&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7a061e"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QList,QItem,QItemSection,QAvatar,QIcon,QItemLabel,QInnerLoading});qInstall(script, 'directives', {Ripple});
